import { FC } from 'react';

import darkMode from '@/public/images/theme_features/dark_mode.svg';

import NextImage from '../UI/nextImage/NextImage';
import { Title } from '../UI/title/Title';

import styles from './DarkMode.module.scss';

interface DarkModeCardProps {
    large?: boolean;
}

const DarkMode: FC<DarkModeCardProps> = () => {
    return (
        <div className={`${styles.theme} `}>
            <div className={styles.theme__top}>
                <div className={styles.theme__info}>
                    <Title text="Enjoy the Dark Mode" size="sm" className={styles.heading} />
                    <p className={`excerpt body-lg ${styles.excerpt}`}>
                        Activate dark mode with just a click for reduced eye strain and a modern
                        look in your Ghost theme&apos;s interface.
                    </p>
                </div>
            </div>

            <div className={styles.devices}>
                <div className={styles['dark-mode']}>
                    <NextImage
                        src={darkMode.src}
                        alt="Dark Mode"
                        fill
                        loading="lazy"
                        sizes="(max-width: 576px) 80vw, 
                                (max-width: 768px) 488px, 
                                (max-width: 1024px) 540px,
                                (max-width: 1150px) 40.15vw, 
                                (max-width: 1300px) 38vw, 488px"
                    />
                </div>
            </div>
        </div>
    );
};

export default DarkMode;
